import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserControls from 'flarum/forum/utils/UserControls';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from 'flarum/common/components/Button';
export default function () {
  extend(CommentPost.prototype, 'elementAttrs', function (elementAttrs) {
    const user = this.attrs.post.user();
    const ignored = user && user.ignored();
    const ignoreLevel = user && user.ignoreLevel();
    if (ignored) {
      elementAttrs.className += ' Post--ignored';
      if (ignoreLevel === 1) {
        elementAttrs.className += ' Post--ignored-total';
      } else {
        elementAttrs.className += ' Post--hidden';
      }
    }
    return elementAttrs;
  });
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const post = this.attrs.post;
    const user = post.user();
    if (!user || !user.ignored()) {
      return;
    }
    if (user.ignoreLevel() === 1) {
      // Total ignore: replace user info with generic
      if (items.has('user')) {
        items.replace('user', m('span', {
          className: 'PostUser--ignored'
        }, [m('i', {
          className: 'fas fa-user-secret'
        }), ' ', app.translator.trans('bizkaitarra-ignore-users.forum.post.ignored_user_placeholder')]));
      }
      return;
    }
    if (post.isHidden()) {
      return;
    }
    items.add('ignore-toggle', Button.component({
      className: 'Button Button--default Button--more',
      icon: 'fas fa-ellipsis-h',
      onclick: this.toggleContent.bind(this)
    }));
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this.attrs.post;
    const user = post.user();
    if (user && user.ignored() && user.ignoreLevel() === 1) {
      items.remove('reply');
      items.remove('like');
      items.remove('reactions');
      items.remove('fof-reactions');
      items.remove('mention');
    }
  });
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    const user = post.user();
    if (user && user.ignored() && user.ignoreLevel() === 1) {
      items.remove('replies');
    }
  });

  // Hide quotes of ignored users
  extend(CommentPost.prototype, 'oncreate', function () {
    this.hideIgnoredQuotes();
  });
  extend(CommentPost.prototype, 'onupdate', function () {
    this.hideIgnoredQuotes();
  });
  CommentPost.prototype.hideIgnoredQuotes = function () {
    const actor = app.session.user;
    if (!actor) return;
    const totalIgnoredIds = (actor.totalIgnoredUserIds() || []).map(id => String(id));
    const totalIgnoredUsernames = (actor.totalIgnoredUsernames() || []).map(u => u.toLowerCase());

    // Also collect from store models loaded on page
    app.store.all('users').forEach(u => {
      if (u.ignored() && u.ignoreLevel() === 1) {
        const idStr = String(u.id());
        if (!totalIgnoredIds.includes(idStr)) {
          totalIgnoredIds.push(idStr);
        }
        if (u.username() && !totalIgnoredUsernames.includes(u.username().toLowerCase())) {
          totalIgnoredUsernames.push(u.username().toLowerCase());
        }
        if (u.displayName && u.displayName() && !totalIgnoredUsernames.includes(u.displayName().toLowerCase())) {
          totalIgnoredUsernames.push(u.displayName().toLowerCase());
        }
      }
    });
    if (totalIgnoredIds.length === 0 && totalIgnoredUsernames.length === 0) return;
    const $blockquotes = this.$('blockquote');
    if (!$blockquotes || $blockquotes.length === 0) return;

    // Process from deepest to outermost so inner nested quotes get handled first
    $($blockquotes.get().reverse()).each(function () {
      const $this = $(this);
      if ($this.hasClass('Quote--ignored')) return;
      let shouldHide = false;

      // 1. Check direct .PostMention and .UserMention elements belonging to this blockquote
      const $mentions = $this.find('.PostMention, .UserMention').filter(function () {
        return $(this).closest('blockquote').is($this);
      });
      $mentions.each(function () {
        const $mention = $(this);

        // A) If PostMention, check data-id (postId) via post store
        const dataId = $mention.attr('data-id');
        if (dataId) {
          if ($mention.hasClass('UserMention') && totalIgnoredIds.includes(String(dataId))) {
            shouldHide = true;
            return false;
          }
          if ($mention.hasClass('PostMention')) {
            const postModel = app.store.getById('posts', dataId);
            if (postModel && postModel.user()) {
              const authorId = String(postModel.user().id());
              if (totalIgnoredIds.includes(authorId)) {
                shouldHide = true;
                return false;
              }
              const authorUsername = (postModel.user().username() || '').toLowerCase();
              if (authorUsername && totalIgnoredUsernames.includes(authorUsername)) {
                shouldHide = true;
                return false;
              }
              const authorDisplayName = (postModel.user().displayName && postModel.user().displayName() || '').toLowerCase();
              if (authorDisplayName && totalIgnoredUsernames.includes(authorDisplayName)) {
                shouldHide = true;
                return false;
              }
            }
          }
        }

        // B) Check mention text (author username or display name)
        const rawText = $mention.text().trim();
        const cleanName = rawText.replace(/^@/, '').trim().toLowerCase();
        if (cleanName && totalIgnoredUsernames.includes(cleanName)) {
          shouldHide = true;
          return false;
        }

        // C) Check mention href (e.g. /u/username)
        const href = $mention.attr('href') || '';
        const userSlugMatch = href.match(/\/u\/([^/?#]+)/);
        if (userSlugMatch) {
          const slug = decodeURIComponent(userSlugMatch[1]).toLowerCase();
          if (totalIgnoredUsernames.includes(slug)) {
            shouldHide = true;
            return false;
          }
        }
      });

      // 2. Check <cite> tags (BBCode quotes: [quote="Username"])
      if (!shouldHide) {
        const $cite = $this.find('cite').filter(function () {
          return $(this).closest('blockquote').is($this);
        });
        if ($cite.length) {
          const citeText = $cite.text().trim().toLowerCase();
          for (const name of totalIgnoredUsernames) {
            if (name && (citeText.startsWith(name) || citeText.includes(name))) {
              shouldHide = true;
              break;
            }
          }
        }
      }

      // 3. Fallback: check opening text of the blockquote for @Username or Username:
      if (!shouldHide) {
        const directText = $this.clone().children('blockquote').remove().end().text().trim().toLowerCase();
        for (const name of totalIgnoredUsernames) {
          if (name) {
            const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`^@?${escaped}(?:\\s*[:]|\\s+wrote|\\s+escribió|\\s+idatzi|\\s|$)`, 'i');
            if (regex.test(directText)) {
              shouldHide = true;
              break;
            }
          }
        }
      }
      if (shouldHide) {
        $this.addClass('Quote--ignored');
        $this.html(`<div class="Quote--ignored-placeholder"><i class="fas fa-eye-slash"></i> <em>${app.translator.trans('bizkaitarra-ignore-users.forum.post.quote_ignored_placeholder')}</em></div>`);
      }
    });
  };
}